import { observer } from 'mobx-react';
import { Maybe } from 'maybeasy';
import { T } from '../../../../../../../Translations';
import { ProductLicenseResource } from '../../../../../Types';

interface Props {
  selectedProductLicense: Maybe<ProductLicenseResource>;
}

function Title({ selectedProductLicense }: Props) {
  return selectedProductLicense
    .map((productLicenseResource) => {
      const name = productLicenseResource.payload.licenseTypePublicName;
      const licenseQuantity = productLicenseResource.payload.licenseQuantity;

      return (
        <div>
          <p className="mr-2 inline-block text-sm font-semibold">
            {name.map((name) => name.text).getOrElseValue('')}
          </p>
          <p className="inline-block text-sm">
            (<T kind="{{count}} License Available" count={licenseQuantity} />)
          </p>
        </div>
      );
    })
    .getOrElse(() => (
      <p className="mr-2 text-sm font-semibold">
        <T kind="No product license selected" />
      </p>
    ));
}

export default observer(Title);
